var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/extensions/TextExtension.ts
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-button.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import { XNativeDialog } from "@adornis/dialog/x-native-dialog.js";
import "@adornis/fonts/fonts.js";
import "@adornis/tiptap/client/x-tiptap.js";
import { html, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";
import { BaseText } from "../../db/extensions/text/BaseText.js";
import { ExtensionBoilerplate } from "./ContentExtensionBoilerplate.js";
var TextExtension = (tiptapExtensions) => ({
  class: BaseText,
  toolbar: { icon: "description", text: { default: "Text" } },
  render(instance, { defaultValues, isSubelement, dropzoneBefore, dropzoneAfter }) {
    return xComponents(html`
      <x-text-extension
        .tiptapExtensions=${tiptapExtensions}
        .content=${instance}
        .defaultValues=${defaultValues}
        ?sub=${isSubelement}
        .hasDropzoneBefore=${dropzoneBefore}
        .hasDropzoneAfter=${dropzoneAfter}
      ></x-text-extension>
    `);
  },
  showDefaultEditor: false,
  editor({ content, contentController, controllerBaseKeyPath, host }) {
    return html`
      <x-flex space="xxs">
        <x-tiptap
          mode="json-string"
          .extensions=${tiptapExtensions}
          ${contentController.field(...controllerBaseKeyPath, "text")}
        ></x-tiptap>
        <x-button
          ${css({ alignSelf: "end" })}
          @click=${async () => {
      const newText = await XTextExtensionEditorFullscreenPrompt.showPopup({
        modal: true,
        closeOnEscape: false,
        props: { text: content.text, tiptapExtensions }
      });
      if (typeof newText !== "string")
        return;
      content.setValue("text", newText, contentController.size);
      host.requestUpdate();
    }}
        >
          Vollbildmodus öffnen
        </x-button>
      </x-flex>
    `;
  },
  group: "Schriften"
});
var XTextExtensionEditorFullscreenPrompt = class extends XNativeDialog {
  content() {
    return html`
      <x-flex padding="md" space="md">
        <x-tiptap
          .extensions=${this.tiptapExtensions}
          .value=${this.text}
          ${css({ width: "100%", height: "100%" })}
          mode="json-string"
          @value-picked=${(e) => {
      this.text = e.detail.value;
    }}
        >
        </x-tiptap>
        <x-flex horizontal end>
          <x-button icon="save" @click=${() => this.close(this.text)}> Speichern & Schließen </x-button>
        </x-flex>
      </x-flex>
    `;
  }
  cancel() {
    this.close(this.text);
  }
  get _dialogStyle() {
    return {
      height: "100%",
      width: "100%",
      overflow: "auto"
    };
  }
  static get element_name() {
    return "x-text-extension-editor-fullscreen-prompt";
  }
  styles() {
    return [
      ...super.styles(),
      {
        ":host": {
          width: "100%",
          height: "100%"
        }
      }
    ];
  }
};
__decorateClass([
  property({ attribute: false })
], XTextExtensionEditorFullscreenPrompt.prototype, "tiptapExtensions", 2);
__decorateClass([
  property({ attribute: false })
], XTextExtensionEditorFullscreenPrompt.prototype, "text", 2);
XTextExtensionEditorFullscreenPrompt = __decorateClass([
  customElement("x-text-extension-editor-fullscreen-prompt")
], XTextExtensionEditorFullscreenPrompt);
var emptyContentJson = {
  type: "doc",
  content: [
    {
      type: "paragraph",
      content: [
        {
          type: "text",
          text: "Beispieltext"
        }
      ]
    }
  ]
};
var XTextExtension = class extends ExtensionBoilerplate {
  _content(content) {
    if (content.text && !this.isJson(content.text))
      return nothing;
    return xComponents(html`
      <x-tiptap
        mode="json-string"
        disabled
        plain
        .extensions=${this.tiptapExtensions}
        .value=${content.text ?? JSON.stringify(emptyContentJson)}
        ${css({ width: "100%", height: "100%" })}
      >
      </x-tiptap>
    `);
  }
  isJson(str) {
    try {
      const a = JSON.parse(str);
      return a && typeof a === "object";
    } catch {
      return false;
    }
  }
};
__decorateClass([
  property({ attribute: false })
], XTextExtension.prototype, "tiptapExtensions", 2);
XTextExtension = __decorateClass([
  customElement("x-text-extension")
], XTextExtension);
export {
  TextExtension,
  XTextExtension,
  XTextExtensionEditorFullscreenPrompt,
  emptyContentJson
};
